import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { Weddings } from '../../Weddings';
import type { Agent } from '../Agents';
import type { IConversation } from './Conversations.types';
import { Messages } from './Conversations/Messages';

@Identifiable
@Timestampable
export class Conversation extends AbstractDocument<IConversation> {
  readonly collections = {
    Messages: new Messages(this),
  };

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}

export class Conversations extends AbstractCollection<Conversation, IConversation> {
  static path = 'conversations';

  /** The agent's default conversation — one per agent, under a well-known id. */
  static DEFAULT = '00000000-0000-4000-8000-000000000000' as const;

  constructor(document: Agent) {
    super(document.collection(Conversations.path), Conversation);
  }

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}
